<div class="empty {{ addClasses }}" [ngClass]="{ 'mod-text-light': textLight }">
  <div class="empty-content">
    @if (headline?.length) {
      <h4 class="empty-headline">{{ getHeadline() }}</h4>
    }
    @if (!isLoading) {
      <p class="empty-text">{{ text | translate }}</p>
    }
    @if (buttonText?.length) {
      <div>
        <a
          class="empty-button btn btn-primary {{ addButtonClass }}"
          (click)="buttonClick?.emit()"
          (keydown.enter)="buttonClick?.emit()"
          [tabIndex]="0">
          @if (buttonIcon?.length) {
            <span class="{{ buttonIcon }}"></span> &nbsp;
          }
          <span class="button-weight">{{ buttonText | translate }}</span>
        </a>
      </div>
    }
  </div>
</div>
